import type { IconName } from "@similarweb/icons";
import { SWReactIcons } from "@similarweb/icons";
import { colorsPalettes } from "@similarweb/styles";

import { SignalsListTypeItemWrapper } from "./SignalsListTypeItemWrapper";
import { StyledSignalListTypeItemContent, StyledSignalTitle } from "./styles";

interface ISignalsListTypeItemProps {
    title: string;
    count: number;
    icon: IconName;
    onClick?: VoidFunction;
}

export const SignalsListTypeItem = ({ title, count, icon, onClick }: ISignalsListTypeItemProps) => {
    return (
        <SignalsListTypeItemWrapper
            count={count}
            onClick={onClick}
        >
            <StyledSignalListTypeItemContent>
                <SWReactIcons
                    iconName={icon}
                    iconColor={colorsPalettes.carbon[200]}
                    size="sm"
                />
                <StyledSignalTitle>{title}</StyledSignalTitle>
            </StyledSignalListTypeItemContent>
        </SignalsListTypeItemWrapper>
    );
};
